import AXIOS from "@/axios";
import type {
  CheckoutApiResponse,
  CheckoutPayload,
  StudentByEmailApiResponse,
  VerifyCheckoutPaymentApiResponse,
  VerifyCheckoutPaymentPayload,
} from "./landingCheckout.types";

export const checkoutClassService = async (
  payload: CheckoutPayload
): Promise<CheckoutApiResponse> => {
  const response = await AXIOS.post<CheckoutApiResponse>(
    "/class/api/v1/checkout",
    payload
  );
  return response.data;
};

/** Confirm Razorpay payment after Checkout.js handler succeeds. */
export const verifyCheckoutPaymentService = async (
  payload: VerifyCheckoutPaymentPayload,
  verifyUrl?: string
): Promise<VerifyCheckoutPaymentApiResponse> => {
  const path =
    verifyUrl?.trim() || "/class/api/v1/checkout/verify-payment";
  const response = await AXIOS.post<VerifyCheckoutPaymentApiResponse>(
    path.startsWith("/") ? path : `/${path}`,
    payload
  );
  return response.data;
};

/** Lookup existing student profile for checkout autofill. */
export const getStudentByEmailService = async (
  email: string
): Promise<StudentByEmailApiResponse> => {
  const response = await AXIOS.get<StudentByEmailApiResponse>(
    "/class/api/v1/student/by-email",
    {
      params: { email: email.trim() },
      skipGlobalErrorToast: true,
    }
  );
  return response.data;
};
